import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';

const modeInfo = {
  add: {
    title: '海纜工進新增',
  },
  edit: {
    title: '海纜工進編輯',
  },
  view: {
    title: '海纜工進檢視',
  },
  '': {
    title: '',
  },
};

class SubmarineDetail extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getPPFanSubmarineIdDetail, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getPPFanSubmarineIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { PPFanSubmarineIdDetail: prePPFanSubmarineIdDetail = {} } = preProps;
    const { PPFanSubmarineIdDetail = {}, mode } = this.props;
    if (Object.keys(prePPFanSubmarineIdDetail).length === 0 && Object.keys(PPFanSubmarineIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: PPFanSubmarineIdDetail, old_data: PPFanSubmarineIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('PPFanSubmarineIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      cable_num: data.cable_num,
      cablework_made_stage: data.cablework_made_stage,
      plan_made_date: data.plan_made_date,
      actual_made_date: data.actual_made_date,
      cable_tran_taiwan: data.cable_tran_taiwan,
      is_tran_taiwan: data.is_tran_taiwan,
      cable_tw_date: data.cable_tw_date,
      actual_tw_date: data.actual_tw_date,
      cable_progress: data.cable_progress,
      plan_install_date: data.plan_install_date,
      actual_install_date: data.actual_install_date,

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewPPFanSubmarine } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewPPFanSubmarine(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putPPFanSubmarineIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putPPFanSubmarineIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.cable_num) === '', // 0 海纜段編號
      returnInputValue(data.cablework_made_stage) === '', // 1 製造 進度
      returnInputValue(data.plan_made_date) === '', // 2 製造 預定日期
      returnInputValue(data.actual_made_date) === '', // 3 製造 實際日期
      returnInputValue(data.cable_tran_taiwan) === '', // 4 運輸 需來台
      returnInputValue(data.is_tran_taiwan) === '', // 5 運輸 已來台
      returnInputValue(data.cable_tw_date) === '', // 6 運輸 預定日期
      returnInputValue(data.actual_tw_date) === '', // 7 運輸 實際日期
      returnInputValue(data.cable_progress) === '', // 8 安裝 進度
      returnInputValue(data.plan_install_date) === '', // 9 安裝 預定日期
      returnInputValue(data.actual_install_date) === '', // 10 安裝 實際日期
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '' } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };
    const allRight = errorAry.indexOf(true) === -1;

    const titleWidth = 155;
    const errorLeft = 20 + titleWidth;

    return (
      <div
        style={{
          position: 'absolute',
          left: 13,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflow: 'auto',
          backgroundColor: 'white',
        }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='海纜段編號' bol={true} haveChange={checkChange('cable_num')} />
              <EAA_Select displayBorder disabled={disabled} list={[{ name: '假編號01', value: '假編號01' }, { name: '假編號02', value: '假編號02' }]} value={returnInputValue(data.cable_num)} onChange={data => this.changeData({ label: 'cable_num', data })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <SearchBar style={{ marginTop: 8 }} text='製造'>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='海纜製造進度' bol={true} haveChange={checkChange('cablework_made_stage')} />
                <CircleCheckBox disabled={disabled} value={data.cablework_made_stage === '1'} onClick={() => this.changeData({ label: 'cablework_made_stage', data: '1' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                <CircleCheckBox disabled={disabled} value={data.cablework_made_stage === '2'} onClick={() => this.changeData({ label: 'cablework_made_stage', data: '2' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                <CircleCheckBox disabled={disabled} value={data.cablework_made_stage === '3'} onClick={() => this.changeData({ label: 'cablework_made_stage', data: '3' })} />
                <div style={{ marginLeft: 4 }}>已完成</div>
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol={true} haveChange={checkChange('plan_made_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.plan_made_date)} onChange={data => this.changeData({ label: 'plan_made_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={true} haveChange={checkChange('actual_made_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.actual_made_date)} onChange={data => this.changeData({ label: 'actual_made_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='運輸'>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='海纜需運輸來台' bol={true} haveChange={checkChange('cable_tran_taiwan')} />
                <CircleCheckBox disabled={disabled} value={data.cable_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'cable_tran_taiwan', data: '1' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                <CircleCheckBox disabled={disabled} value={data.cable_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'cable_tran_taiwan', data: '2' })} />
                <div style={{ marginLeft: 4 }}>否</div>
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('is_tran_taiwan')} />
                <CircleCheckBox disabled={disabled} value={data.is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'is_tran_taiwan', data: '1' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                <CircleCheckBox disabled={disabled} value={data.is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'is_tran_taiwan', data: '2' })} />
                <div style={{ marginLeft: 4 }}>否</div>
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='海纜預定抵台日期' bol={true} haveChange={checkChange('cable_tw_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.cable_tw_date)} onChange={data => this.changeData({ label: 'cable_tw_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={true} haveChange={checkChange('actual_tw_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.actual_tw_date)} onChange={data => this.changeData({ label: 'actual_tw_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='安裝'>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='鋪纜進度' bol={true} haveChange={checkChange('cable_progress')} />
                <CircleCheckBox disabled={disabled} value={data.cable_progress === '1'} onClick={() => this.changeData({ label: 'cable_progress', data: '1' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                <CircleCheckBox disabled={disabled} value={data.cable_progress === '2'} onClick={() => this.changeData({ label: 'cable_progress', data: '2' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>施工中</div>
                <CircleCheckBox disabled={disabled} value={data.cable_progress === '3'} onClick={() => this.changeData({ label: 'cable_progress', data: '3' })} />
                <div style={{ marginLeft: 4 }}>已完成</div>
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定安裝完成日期' bol={true} haveChange={checkChange('plan_install_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.plan_install_date)} onChange={data => this.changeData({ label: 'plan_install_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際安裝完成日期' bol={true} haveChange={checkChange('actual_install_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.actual_install_date)} onChange={data => this.changeData({ label: 'actual_install_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewPPFanSubmarine' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutPPFanSubmarineIdDetail' />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  PPFanSubmarineIdDetail: state.data.PPFanSubmarineIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getPPFanSubmarineIdDetail: id => Actions_Wind.getPPFanSubmarineIdDetail(dispatch, { id }),
  postAddNewPPFanSubmarine: body => Actions_Wind.postAddNewPPFanSubmarine(dispatch, { body }),
  putPPFanSubmarineIdDetail: (id, body) => Actions_Wind.putPPFanSubmarineIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmarineDetail);
